import React from "react";

import classNames from "classnames";

import { Tab } from "studio-design-system";

import * as styles from "./SeriesTabs.css";

export const SeriesTabs = ({
  tabs,
  selection,
  setSelection,
}: {
  tabs: Tab[];
  selection: Tab;
  setSelection: (tab: Tab) => void;
}): React.ReactElement => {
  return (
    <>
      <div className={styles.tabContainer}>
        {tabs.map((tab, index) => (
          <div
            className={classNames(styles.tab, selection.value == tab.value && styles.selectedTab)}
            key={`tab_${index.toString()}`}
            onClick={() => setSelection(tab)}
          >
            {tab.title}
          </div>
        ))}
      </div>
    </>
  );
};
